module.exports = __webpack_public_path__ + "static/media/elcorreoandalucia.7ece1377.png";